export default "__VITE_ASSET__BqMFPpgp__"